<template>
  <div
    class="tw-bg-white tw-text-sm tw-text-left tw-w-full tw-flex tw-flex-col tw-rounded-xl tw-space-y-8 tw-relative"
  >
    <div class="tw-p-4 tw-border tw-rounded-lg tw-text-sm tw-relative">
      <span
        class="group-header tw-absolute tw-top-[-0.75rem] tw-font-bold tw-bg-white tw-px-2"
        >Room ID</span
      >
      <div class="tw-flex tw-justify-between tw-items-center">
        <p>{{ selectedRoomID }}</p>
        <button
          @click="onCopyRoomID"
          class="tw-text-gray-400 tw-fill-current tw-rounded-md hover:tw-bg-gray-100 tw-p-1"
        >
          <svg
            class="tw-w-5 tw-h-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              d="M384 96L384 0h-112c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48H464c26.51 0 48-21.49 48-48V128h-95.1C398.4 128 384 113.6 384 96zM416 0v96h96L416 0zM192 352V128h-144c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h192c26.51 0 48-21.49 48-48L288 416h-32C220.7 416 192 387.3 192 352z"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="tw-p-4 tw-border tw-rounded-lg tw-text-sm tw-relative">
      <span
        class="group-header tw-absolute tw-top-[-0.75rem] tw-font-bold tw-bg-white tw-px-2"
        >Channel</span
      >
      <div
        class="channel-selector tw-relative tw-w-full tw-flex tw-flex-row tw-rounded-md tw-overflow-hidden"
      >
        <button
          @click="setChannel('main')"
          :class="`tw-w-1/2 tw-relative tw-py-1 hover:tw-bg-primary-light hover:tw-text-white  ${
            channel === 'main'
              ? 'tw-bg-primary tw-text-white'
              : 'tw-bg-gray-200'
          }`"
        >
          <p>Main</p>
          <div
            v-if="unseenMessage.main"
            class="tw-absolute tw-z-50 tw-top-1 tw-left-1"
          >
            <div
              class="unread-badge tw-absolute tw-animate-ping tw-w-2 tw-h-2 tw-bg-red-400 tw-rounded-full"
            ></div>
            <div
              class="unread-badge tw-absolute tw-w-2 tw-h-2 tw-bg-red-400 tw-rounded-full"
            ></div>
          </div>
        </button>
        <button
          @click="setChannel('background')"
          :class="`tw-w-1/2 tw-py-1 tw-relative hover:tw-bg-primary-light hover:tw-text-white  ${
            channel === 'background'
              ? 'tw-bg-primary tw-text-white'
              : 'tw-bg-gray-200'
          }`"
        >
          <p>Background</p>
          <div
            v-if="unseenMessage.bg"
            class="tw-absolute tw-z-50 tw-top-1 tw-left-1"
          >
            <div
              class="unread-badge tw-absolute tw-animate-ping tw-w-2 tw-h-2 tw-bg-red-400 tw-rounded-full"
            ></div>
            <div
              class="unread-badge tw-absolute tw-w-2 tw-h-2 tw-bg-red-400 tw-rounded-full"
            ></div>
          </div>
        </button>
      </div>
    </div>
    <div class="tw-p-4 tw-border tw-rounded-lg tw-text-sm tw-relative">
      <span
        class="group-header tw-absolute tw-top-[-0.75rem] tw-font-bold tw-bg-white tw-px-2"
        >Tags</span
      >
      <!-- <div class="tw-w-full tw-flex tw-gap-2 tw-flex-wrap tw-h-min tw-py-2">
        <RoomCardTag
          v-for="tag in local.tags"
          :key="tag.Attributes"
          removable
          :tag="tag"
          @on-remove="onRemoveTag"
        />
      </div> -->
      <div class="tw-relative">
        <div
          v-click-outside="outside"
          v-if="tagsSelectorIsActive"
          class="tw-bg-white tw-z-10 tw-absolute tw-top-0 tw-left-0 tw-flex-wrap tw-shadow-lg tw-box-border input-box tw-w-full tw-flex tw-flex-col tw-items-start tw-overflow-hidden tw-rounded-md"
        >
          <div
            class="tw-flex-none tw-flex tw-flex-wrap tw-gap-2 tw-justify-start tw-items-center tw-bg-gray-50 tw-border-b tw-w-full tw-p-2"
          >
            <RoomCardTag
              v-for="tag in local.tags"
              :key="tag.Attributes"
              :tag="tag"
              removable
              @on-remove="onRemoveTag"
            />
            <input
              ref="tagFilterInput"
              class="tw-ring-0 focus:tw-ring-0 focus:tw-ring-offset-0 focus:tw-outline-none tw-bg-transparent"
              type="text"
              placeholder="Search for option..."
              v-model="tagFilterInput"
            />
          </div>
          <div class="tw-p-2 tw-w-full tw-flex-auto">
            <div class="tw-flex tw-gap-1">
              <p class="tw-text-gray-600 tw-flex-none">Select an option</p>
              <p v-if="allowCreateTag" class="tw-text-gray-600 tw-flex-none">
                or
              </p>
              <button
                v-if="allowCreateTag"
                @click="showCreateNewTagForm = !showCreateNewTagForm"
                class="tw-text-primary hover:tw-underline"
              >
                create new tag
              </button>
            </div>

            <form
              v-if="showCreateNewTagForm"
              @submit.prevent="onAddTag"
              class="action tw-flex tw-border tw-rounded-lg tw-my-2 tw-overflow-hidden tw-w-full"
            >
              <select
                class="tw-bg-primary tw-flex-none tw-text-white tw-text-sm focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-block tw-w-fit tw-p-1"
                v-model="form.selected"
              >
                <option
                  v-for="option in roomSettings.tag.options"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.name }}
                </option>
              </select>
              <input
                v-if="form.selected === 'order'"
                class="tw-px-2 tw-w-full tw-h-8 tw-bg-slate-50"
                type="text"
                placeholder="Order ID"
                v-model="form.orderID"
              />
              <input
                v-else
                class="tw-px-2 tw-w-full tw-h-8 tw-bg-white"
                type="text"
                placeholder="Title"
                v-model="form.title"
              />
              <button
                class="tw-bg-primary tw-flex-none tw-text-white tw-px-4"
                type="submit"
              >
                Add
              </button>
            </form>

            <div
              v-for="tag in filteredTags"
              @click="onSelectTag(tag)"
              :key="tag.Attributes"
              class="tw-w-full hover:tw-bg-gray-100 tw-p-1 hover:tw-cursor-pointer"
            >
              <RoomCardTag :tag="tag" />
            </div>
          </div>
        </div>
        <div
          class="input-box tw-h-8 tw-w-full tw-p-2 tw-flex tw-flex-wrap tw-border tw-rounded-md hover:tw-cursor-pointer tw-text-center tw-items-center tw-gap-2"
          @click.prevent="onClickTagsBox"
        >
          <RoomCardTag
            v-for="tag in local.tags"
            :key="tag.Attributes"
            :tag="tag"
          />
        </div>
      </div>
    </div>
    <div
      class="user-info tw-p-4 tw-border tw-rounded-lg tw-text-sm tw-relative tw-min-h-[4rem]"
    >
      <span
        class="group-header tw-absolute tw-top-[-0.75rem] tw-font-bold tw-bg-white tw-px-2"
        >Notes</span
      >
      <div
        v-if="notes.length > 0"
        class="note-list tw-h-full tw-flex-auto tw-flex-col tw-overflow-auto"
      >
        <RemovableNote
          v-for="note in notes.slice().reverse()"
          :key="note.Attributes"
          :note="note"
          @remove-note="onRemoveNote"
          :removable="true"
        ></RemovableNote>
      </div>
      <!-- <div class="" v-else>
        <p>Empty.</p>
      </div> -->
      <form
        @submit.prevent="onAddNote"
        class="add-note tw-flex-none tw-flex tw-h-8 tw-my-2"
      >
        <input
          class="tw-w-full tw-px-2 tw-border-gray-300 tw-border tw-rounded-l-md"
          type="text"
          v-model.trim="noteInput"
        />
        <button
          class="tw-w-fit tw-text-white tw-px-2 tw-bg-primary hover:tw-bg-primary-light tw-rounded-r-md"
          type="submit"
        >
          Add
        </button>
      </form>
    </div>
    <div
      v-if="allowUpdateRoomStatus"
      class="tw-p-4 tw-border tw-rounded-lg tw-text-sm tw-relative"
    >
      <span
        class="group-header tw-absolute tw-top-[-0.75rem] tw-font-bold tw-bg-white tw-px-2"
        >Room Control</span
      >
      <div
        class="channel-selector tw-relative tw-w-full tw-flex tw-flex-row tw-rounded-md tw-overflow-hidden"
      >
        <button
          v-if="(room && room.Status === 'opened') || room.Status === 'abandon'"
          @click="onCloseRoom"
          class="tw-w-full tw-relative tw-py-1 tw-bg-red-500 tw-text-white hover:tw-bg-red-400 hover:tw-text-white"
        >
          <p class="tw-uppercase">Close chat room</p>
        </button>
        <button
          v-else-if="room && room.Status === 'closed'"
          @click="onOpenRoom"
          class="tw-w-full tw-relative tw-py-1 tw-bg-green-500 tw-text-white hover:tw-bg-green-400 hover:tw-text-white"
        >
          <p class="tw-uppercase">Open chat room</p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
import Cronr from "cronr";

const WAIT = 1000;

export default {
  name: "ChatNote",
  components: {
    RemovableNote: () => import("./RemovableNote.vue"),
    RoomCardTag: () => import("./RoomCardTag.vue"),
  },
  data() {
    return {
      noteInput: null,
      notes: [],
      local: {
        tags: [],
      },
      roomSettings: {
        tag: {
          options: [
            {
              name: "Issue Tag",
              value: "issue",
            },
            {
              name: "Order Tag",
              value: "order",
            },
            {
              name: "Customer Tag",
              value: "customer",
            },
          ],
        },
      },
      form: {
        title: "",
        orderID: "",
        selected: "issue",
      },
      tagsSelectorIsActive: false,
      showCreateNewTagForm: false,
      // tags: [],
      tagFilterInput: "",
      disable: true,

      lastMessage: {
        main: null,
        background: null,
      },
      unseenMessage: {
        main: false,
        bg: false,
      },
      notePollingJob: null,
      updateLocalTagsTimeout: null,
      // myAgentInfo: null,
    };
  },
  computed: {
    ...mapGetters({
      selectedRoomID: "chat/selectedRoomID",
      room: "chat/room",
      user: "chat/user",
      decoded: "chat/decoded",
      channel: "chat/channel",
      tags: "chat/tags",
      roomSocket: "chat/roomSocket",
      myAgentInfo: "chat/myAgentInfo",
    }),
    senderID() {
      // if (this.user) {
      //   return this.user.attributes.sub;
      // }
      if (this.decoded) {
        return this.decoded["cognito:username"];
      }
      return null;
    },
    participants() {
      if (this.room) {
        if (this.channel === "main") {
          return this.room.MainChannel.Participants || [];
        }
        if (this.channel === "background") {
          return this.room.BackgroundChannel.Participants || [];
        }
      }
      return [];
    },
    activePaticipant() {
      const stack = this.room?.MainChannel?.ParticipantStack;
      if (!stack) {
        return null;
      }
      return this.participants.find((p) => p.ID === stack.at(-1));
    },
    isActiveParticipant() {
      if (this.channel === "background") {
        if (this.myCurrentInfo) {
          return true;
        }
      }
      if (!this.user || !this.activePaticipant) {
        return false;
      }
      return this.activePaticipant.Name === this.user.username;
    },
    myCurrentInfo() {
      return (
        this.participants.find((p) => p.Name === this.user.username) || null
      );
    },
    filteredTags() {
      if (!this.tagFilterInput) return this.tags;
      return this.tags.filter((tag) => {
        const index = tag.Title.toLowerCase().search(this.tagFilterInput);
        if (index !== -1) {
          return true;
        }
        return false;
      });
    },
    allowCreateTag() {
      return (
        this.myAgentInfo?.Role === "Admin" ||
        this.myAgentInfo?.Role === "Service"
      );
    },
    allowUpdateRoomStatus() {
      const participants = this.room?.MainChannel?.ParticipantStack;
      if (!participants) {
        return false;
      }
      if (participants.length === 0) {
        return false;
      }
      const participantIdx = participants.findIndex((p) => p === this.senderID);
      return participantIdx === 0 || participantIdx === participants.length - 1;
    },
    // unseenMessage() {
    //   const result = {
    //     main: false,
    //     bg: false,
    //   };
    //   const lastMainMsg = this.lastMessage?.main[0] || null;
    //   const lastBgMsg = this.lastMessage?.background[0] || null;

    //   if (lastMainMsg) {
    //     const mainSeenBy = lastMainMsg?.SeenBy;
    //     result.main =
    //       mainSeenBy.findIndex((sb) => sb.search(this.senderID) !== -1) === -1;
    //   }

    //   if (lastBgMsg) {
    //     const bgSeenBy = lastBgMsg?.SeenBy;
    //     result.bg =
    //       bgSeenBy.findIndex((sb) => sb.search(this.senderID) !== -1) === -1;
    //   }

    //   return result;
    // },
  },
  async mounted() {
    // this.myAgentInfo = await this.$store.dispatch(
    //   "chat/getAgentByAgentID",
    //   this.decoded["cognito:username"]
    // );

    this.syncTags();
    const pattern = "*/30 * * * * *";
    this.notePollingJob = new Cronr(pattern, () => {
      this.fetchNote();
    });
    this.notePollingJob.start();
  },
  watch: {
    selectedRoomID: {
      immediate: true,
      handler: async function (value) {
        this.clearNote();
        this.fetchNote();
        await this.getLastMessage(value);
        await this.updateLocalTags();
      },
    },
    tagsSelectorIsActive: {
      handler: function (value) {
        if (value) {
          this.syncTags();
        }
      },
    },
    roomSocket: {
      immediate: true,
      handler(value) {
        if (value) {
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          let me = this;
          value.addEventListener("message", async function (event) {
            const message = JSON.parse(event.data);
            console.log("Message from room socket in chat note", message);
            if (message.Attributes === "Typing") {
              //Do nothing
            } else {
              me.handlerMessage(message);
            }
          });
        }
      },
    },
    lastMessage: {
      immediate: false,
      handler() {
        const result = {
          main: false,
          bg: false,
        };
        const lastMainMsg = this.lastMessage?.main || null;
        const lastBgMsg = this.lastMessage?.background || null;

        if (lastMainMsg) {
          const mainSeenBy = lastMainMsg?.SeenBy;
          if (!lastMainMsg.Type) {
            result.main = false;
          } else if (!mainSeenBy) {
            result.main = true;
          } else {
            result.main =
              mainSeenBy?.findIndex((sb) => sb === this.senderID) === -1;
          }
        }

        if (lastBgMsg) {
          const bgSeenBy = lastBgMsg?.SeenBy;
          if (!lastBgMsg.Type) {
            result.bg = false;
          } else if (!bgSeenBy) {
            result.bg = true;
          } else {
            result.bg =
              bgSeenBy?.findIndex((sb) => sb === this.senderID) === -1;
          }
        }

        // console.log("last message watcher", lastMainMsg, lastBgMsg, result);

        this.unseenMessage = result;
      },
      deep: true,
    },
    // "room.Status": {
    //   handler: function () {
    //     EventBus.$emit("update-local-tags");
    //   },
    // },
  },
  methods: {
    handlerMessage(message) {
      if (message.Type === "text" || message.Type === "image") {
        console.log("handlerMessage", message);
        this.lastMessage[message.Channel] = message;
      }
    },

    async syncTags() {
      await this.$store.dispatch("chat/listTags");
      // this.tags = tags;
    },
    async onAddNote() {
      if (!this.selectedRoomID) {
        console.log("No room selected");
        return;
      }
      let payload = {
        roomID: this.selectedRoomID,
        creatorID: this.senderID,
        creatorName: this.senderID,
        text: this.noteInput,
      };

      await this.$store.dispatch("chat/addNoteToRoomID", payload);

      payload["CreatedAt"] = dayjs();
      payload["Text"] = this.noteInput;
      payload["CreatorName"] = this.senderID;
      this.notes.splice(0, 0, payload);

      this.noteInput = null;
      setTimeout(async () => {
        await this.fetchNote();
      }, WAIT);
    },
    async fetchNote() {
      //Fetch notes
      const notePayload = {
        roomID: this.selectedRoomID,
      };

      const notesResponse = await this.$store.dispatch(
        "chat/getNotesByRoomID",
        notePayload
      );
      console.log(notesResponse);
      this.notes = notesResponse.notes;
    },

    clearNote() {
      this.notes = [];
      this.noteInput = null;
    },

    onRemoveNote(id) {
      console.log(id);
      this.notes = this.notes.filter((n) => n.ID !== id);
      setTimeout(async () => {
        await this.fetchNote();
      }, WAIT * 10);
    },
    onCopyRoomID() {
      const root = window.location.origin;
      navigator.clipboard.writeText(root + `/chat/${this.selectedRoomID}`);
    },
    setChannel(ch) {
      this.$store.commit("chat/setChannel", ch);
    },
    async updateLocalTags() {
      // console.log("update local tags");
      let tags = [];
      const room = await this.$store.dispatch(
        "chat/getRoom",
        this.selectedRoomID
      );

      EventBus.$emit("update-local-tags", room);

      room?.IssueTags?.map((t) => tags.push(t));
      room?.CustomerTags?.map((t) => tags.push(t));
      room?.OrderTags?.map((t) => tags.push(t));
      this.local.tags = tags;
    },
    async onAddTag() {
      const error = this.validateForm();
      if (error) {
        alert(error);
        return;
      }

      console.log("onAddTag", this.form);
      await this.$store.dispatch("chat/addTag", {
        Type: this.form.selected,
        Title: this.form.title,
        OrderID: this.form.orderID,
      });

      // Add local tag
      const temp = {
        Attributes:
          this.form.selected === "order"
            ? `Tag-${this.form.selected}#${this.form.orderID}`
            : `Tag-${this.form.selected}#${this.form.title}`,
        CreatedAt: null,
        CreatorID: null,
        CreatorName: null,
        OrderId: this.form.orderID,
        RoomID: this.selectedRoomID,
        Title: this.form.title,
        Type: this.form.selected,
        UpdatedAt: null,
      };
      this.local.tags.push(temp);
      this.form.title = "";
      this.form.orderID = "";
      setTimeout(() => {
        this.updateLocalTags();
      }, 1000);
    },
    validateForm() {
      if (this.form.selected === "issue" || this.form.selected === "customer") {
        if (!this.form.title) {
          return "field: tag title is required!";
        }
      }
      if (this.form.selected === "order") {
        if (!this.form.orderID) {
          return "field: order ID is required!";
        }
      }
      return null;
    },
    async onRemoveTag(e) {
      clearTimeout(this.updateLocalTagsTimeout);
      console.log(e);
      await this.$store.dispatch("chat/removeTag", e);
      const tags = this.local.tags;
      const clone = tags.filter((c) => {
        if (e.Type === "order") {
          if (c.OrderId === e.OrderId) {
            return false;
          }
          return true;
        }
        if (e.Title === c.Title) {
          return false;
        }
        return true;
      });
      this.local.tags = clone;
      this.updateLocalTagsTimeout = setTimeout(() => {
        this.updateLocalTags();
      }, 1000);
    },
    onClickTagsBox() {
      this.tagsSelectorIsActive = true;
      this.$nextTick(() => this.$refs.tagFilterInput.focus());
      setTimeout(() => {
        this.disable = false;
      }, 100);
    },
    async onSelectTag(tag) {
      clearTimeout(this.updateLocalTagsTimeout);
      const temp = {
        Attributes: `Tag-${tag.Type}}#${tag.Title}`,
        CreatedAt: null,
        CreatorID: null,
        CreatorName: null,
        OrderId: "",
        RoomID: this.selectedRoomID,
        Title: tag.Title,
        Type: tag.Type,
        UpdatedAt: null,
      };
      this.local.tags.push(temp);

      await this.$store.dispatch("chat/addTag", {
        Type: tag.Type,
        Title: tag.Title,
      });

      this.updateLocalTagsTimeout = setTimeout(() => {
        this.updateLocalTags();
      }, 1000);
    },
    outside: function () {
      // console.log("outside", this.tagsSelectorIsActive, this.disable);
      if (this.disable) {
        return;
      } else {
        if (this.tagsSelectorIsActive) {
          this.tagsSelectorIsActive = false;
          this.disable = true;
        }
      }
    },
    async getLastMessage(roomID) {
      const room = await this.$store.dispatch("chat/getRoom", roomID);
      this.lastMessage.main = room?.MainChannel?.LastMessage;
      this.lastMessage.background = room?.BackgroundChannel?.LastMessage;
    },
    async onCloseRoom() {
      console.log("onCloseRoom");
      if (window.confirm("Do you want to close this room?")) {
        await this.$store.dispatch("chat/closeRoom", this.selectedRoomID);
      }
    },
    async onOpenRoom() {
      console.log("onOpenRoom");
      if (window.confirm("Do you want to reopen this room?")) {
        await this.$store.dispatch("chat/reOpenRoom", this.selectedRoomID);
      }
    },
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function (el) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  beforeDestroy() {
    this.notePollingJob.clear();
    this.notePollingJob = null;
  },
};
</script>

<style scoped>

/* * {
  border: 1px solid red;
} */

</style>
